import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FilterableMenuItem } from 'owa-filterable-menu';
import { CommandButton } from '@fluentui/react/lib/Button';
import { PreviewPaneErrorViewState } from 'owa-sxsdata';

const styles = require('./PreviewError.scss');

export interface PreviewErrorProps {
    viewState: PreviewPaneErrorViewState;
    commandItems: FilterableMenuItem[];
}

export const PreviewError = observer(function PreviewError(props: PreviewErrorProps) {
    const {
        viewState: { errorMessage },
        commandItems,
    } = props;

    return (
        <div className={styles.container}>
            <div className={styles.errorMessageText}>{errorMessage}</div>
            {commandItems && commandItems.length > 0 && (
                <ul className={styles.actions}>
                    {commandItems.map(item => (
                        <ActionButton key={item.key} item={item} />
                    ))}
                </ul>
            )}
        </div>
    );
});

interface ActionButtonProps {
    item: FilterableMenuItem;
}

const ActionButton = observer(function ActionButton(props: ActionButtonProps) {
    const { item } = props;
    const onClick = React.useCallback(
        (evt: React.MouseEvent<unknown>) => {
            item.onClick(evt, item);
        },
        [item.onClick]
    );

    return (
        <CommandButton
            aria-hidden={true}
            className={styles.actionButton}
            iconProps={item.iconProps}
            onClick={onClick}
            text={item.name}
        />
    );
});
